<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
export default {
}
</script>
<style lang="less">
@import '~variables';

div.alert {
    z-index: 2000;
}

#app {
    font-family: 'Lato', 'Montserrat', 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    height: 100%;

    .jumbotron {
        background-color: @base;
        color: @base-text;
    }

    .form-inline {
        .form-group {
            margin-right: 2rem;
        }
    }

  .action-block {
    .btn {
      margin-right: 1rem;
    }
  }
}
</style>
